import React from 'react';
import styles from './CreditCardInfo.scss';

const recordDisplay = text => (text ? text : '―');

const CreditCardInfo = ({ cardInfo = {}, className }) => (
  <div className={className}>
    <dl className={styles.cardField}>
      <dt>カード番号：</dt>
      <dd>{recordDisplay(cardInfo.last4 && `XXXX XXXX XXXX ${cardInfo.last4}`)}</dd>
    </dl>
    <dl className={styles.cardField}>
      <dt>有効期限：</dt>
      <dd>{recordDisplay(cardInfo.exp_year && cardInfo.exp_month && `${cardInfo.exp_month}/${cardInfo.exp_year}`)}</dd>
    </dl>
    <dl className={styles.cardField}>
      <dt>名前：</dt>
      <dd>{recordDisplay(cardInfo.name)}</dd>
    </dl>
    <dl className={styles.cardField}>
      <dt>カードタイプ：</dt>
      <dd>{recordDisplay(cardInfo.brand)}</dd>
    </dl>
  </div>
);

export default CreditCardInfo;
